import Link from 'next/link';
import { Button } from '@savvy-kit/components/button';

type PortalCardLinkActionProps = {
  readonly href: string;
  readonly label: string;
};

export function PortalCardLinkAction({ href, label }: PortalCardLinkActionProps) {
  return (
    <Button variant="ghost" size="sm" className="text-dark" render={<Link href={href} />}>
      {label}
    </Button>
  );
}
